export default __webpack_public_path__ + "static/media/cyber-2377718_640.fa9245cf.jpg";